import { ErrorSimple, Loader } from '@scts-ui/component-library';
import { useConfigLoader } from '@scts/utilities';
import { useAppeals } from '../../utilities/appeals-query';
import { UserRole } from '@scts/models';
import AppealComponent from '../../components/appeal/appeal-component';
import AppealsComponent from '../../components/appeals-appellant/appeals-component';
import MemberCaselist from '../../components/appeals-member/appeals-member';
import { useAuthContext } from '../../contexts/auth/auth-context';

const AppealsManager = () => {
  const config = useConfigLoader();
  const { data, isLoading, isIdle, isError } = useAppeals(
    config.data?.apiUrl ?? '',
    config.data?.configuration.auth.scopes ?? []
  );

  const authContext = useAuthContext();
  if (!authContext) {
    return null;
  }
  const { userRole } = authContext;

  return (
    <>
      {(isLoading || isIdle) && (
        <div>
          <Loader
            loadingText={'attempting to get your appeals'}
            padding={'15% 30%'}
          />
        </div>
      )}

      {!isError &&
        data &&
        data.length > 1 &&
        userRole === UserRole.Appellant && <AppealsComponent appeals={data} />}
      {!isError &&
        data &&
        data.length === 1 &&
        userRole === UserRole.Appellant && <AppealComponent appeal={data[0]} />}

      {!isError && data && data.length > 0 && userRole === UserRole.Member && (
        <MemberCaselist memberAppeals={data} />
      )}

      {/* w2hat are we doing with the actual error info? eg error.message */}
      {isError && (
        <ErrorSimple
          icon="bi-exclamation-square-fill"
          margin="15% 30%"
          message="There has been an error contacting the server. Please try refreshing the page in the first instance, then logging out and back in again if necessary. If you continue to have issues then please contact support"
          padding="0.75rem"
          iconFontSize={'2.9rem'}
          textFontSize={'1rem'}
        />
      )}
      {!isError && data && data.length === 0 && (
        <ErrorSimple
          icon="bi-exclamation-square-fill"
          margin="15% 30%"
          message="You don't seem to have any appeals. Please contact support."
          padding="0.75rem"
          iconFontSize={'2.9rem'}
          textFontSize={'1rem'}
        />
      )}
    </>
  );
};

export default AppealsManager;
